/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var UIUtil = require('psa-core/util/ui');
var parsleyUtil = require('common/util/parsleyUtil');

var Constants = require('../../common/util/constants');

var COCCreateNewEntityModalView = require('./COCCreateNewEntityModalView');
var COCSearchForEntityModalView = require('./COCSearchForEntityModalView');
var COCCreateNewContactModalView = require('./COCCreateNewContactModalView');
var COCSearchForContactModalView = require('./COCSearchForContactModalView');

var tmplCOCEventOrganizationDetailsView = require('../templates/COCEventOrganizationDetailsView.hbs');
require('../styles/COCEventOrganizationDetailsView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEventOrganizationDetailsView,

  className: 'coc-event-organization-details-view',

  ui: {
    organizationDetailsForm: '.organization-details-form',
    organizationName: '.organization-name-input',
    organizationAddress: '.venue-address-input',
    organizationType: '.organization-type-input',
    website: '.website-input',
    contactName: '.contact-name-input',
    contactPhone: '.contact-phone-input',
    contactEmail: '.contact-email-input',
    selectOrganizationFormGroup: '.select-organization-form-group',
    selectOrganizationContactFormGroup: '.select-organization-contact-form-group',
    organizationNameErrorsContainer: '#organizationNameErrorsContainer',
    organizationContactNameErrorsContainer: '#organizationContactNameErrorsContainer',
    organizationAddressErrorsContainer: '#organizationAddressErrorsContainer',
    createEntity: '.btn-create-entity',
    searchEntity: '.btn-search-entity',
    createContact: '.btn-create-contact',
    searchContact: '.btn-search-contact'
  },

  events: {
    'click @ui.createEntity': 'onClickCreateEntity',
    'click @ui.searchEntity': 'onClickSearchEntity',
    'click @ui.createContact': 'onClickCreateContact',
    'click @ui.searchContact': 'onClickSearchContact'
  },

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  onBeforeShow: function() {
    if (this.options.isReadOnly) {
      var organization = this.model.get('organization') || {};
      organization.organizationName = organization.name;
      organization.orgVenueAddress = organization.fullAddress;
      organization.orgWebsite = organization.website;
      organization.orgContactName = organization.organizationContactName;
      organization.orgPhone = organization.contactPhone;
      organization.orgEmail = organization.contactEmail;
      organization.organizationType = organization.type;

      Syphon.deserialize(this, organization);
    }
  },

  onClickCreateEntity: function(e) {
    e.preventDefault();
    var self = this;

    UIUtil.showModal({
      title: 'Create New Entity',
      dialogClasses: 'create-new-entity-modal-dialog',
      view: new COCCreateNewEntityModalView({
        model: new Backbone.Model({
          createEntityType: Constants.ORGANIZATION,
          entityTypes: self.model.get('entityTypes'),
          organizationTypes: self.model.get('organizationTypes')
        })
      })
    }).done(function(newEntity) {
      self.model.set('organizationId', newEntity.newEntityId);
      self.ui.organizationName.val(newEntity.name);
      self.ui.organizationAddress.val(newEntity.fullAddress);
      self.ui.organizationType.val(newEntity.organizationType);
      self.ui.website.val(newEntity.website);

      if (self.ui.selectOrganizationFormGroup.hasClass('has-error')) {
        self.ui.selectOrganizationFormGroup.removeClass('has-error');
        self.ui.organizationNameErrorsContainer.addClass('collapse');
        self.ui.organizationAddressErrorsContainer.addClass('collapse');
      }
    });
  },

  onClickSearchEntity: function(e) {
    e.preventDefault();
    var self = this;

    UIUtil.showModal({
      title: 'Search for Entity',
      dialogClasses: 'search-for-entity-modal-dialog',
      view: new COCSearchForEntityModalView({
        model: new Backbone.Model({
          searchEntityType: Constants.ORGANIZATION,
          entityTypes: self.model.get('entityTypes'),
          organizationTypes: self.model.get('organizationTypes')
        })
      })
    }).done(function(selectedEntity) {
      self.model.set('organizationId', selectedEntity.get('entityId'));
      self.ui.organizationName.val(selectedEntity.get('entityName'));
      self.ui.organizationAddress.val(selectedEntity.get('fullAddress'));
      self.ui.organizationType.val(selectedEntity.get('organizationType'));
      self.ui.website.val(selectedEntity.get('website'));

      if (self.ui.selectOrganizationFormGroup.hasClass('has-error')) {
        self.ui.selectOrganizationFormGroup.removeClass('has-error');
        self.ui.organizationNameErrorsContainer.addClass('collapse');
        self.ui.organizationAddressErrorsContainer.addClass('collapse');
      }
    });
  },

  onClickCreateContact: function(e) {
    e.preventDefault();
    var self = this;

    UIUtil.showModal({
      title: 'Create New Contact',
      dialogClasses: 'create-new-contact-modal-dialog',
      view: new COCCreateNewContactModalView({
        model: new Backbone.Model()
      })
    }).done(function(newContact) {
      self.model.set('contactId', newContact.contactId);
      self.ui.contactName.val(newContact.name);
      self.ui.contactPhone.val(newContact.phone);
      self.ui.contactEmail.val(newContact.email);

      if (self.ui.selectOrganizationContactFormGroup.hasClass('has-error')) {
        self.ui.selectOrganizationContactFormGroup.removeClass('has-error');
        self.ui.organizationContactNameErrorsContainer.addClass('collapse');
      }
    });
  },

  onClickSearchContact: function(e) {
    e.preventDefault();
    var self = this;

    UIUtil.showModal({
      title: 'Search For Contact',
      dialogClasses: 'search-for-contact-modal-dialog',
      view: new COCSearchForContactModalView({
        model: new Backbone.Model({
          searchEntityType: Constants.ORGANIZATION
        })
      })
    }).done(function(selectedContact) {
      self.model.set('contactId', selectedContact.get('contactId'));
      self.ui.contactName.val(selectedContact.get('contactName'));
      self.ui.contactPhone.val(selectedContact.get('contactPhone'));
      self.ui.contactEmail.val(selectedContact.get('contactEmail'));

      if (self.ui.selectOrganizationContactFormGroup.hasClass('has-error')) {
        self.ui.selectOrganizationContactFormGroup.removeClass('has-error');
        self.ui.organizationContactNameErrorsContainer.addClass('collapse');
      }
    });
  },

  validate: function(config) {
    this.ui.organizationDetailsForm.parsley().reset();
    if (config.type === 'save') {
      // Turn off required field validation for this form
      parsleyUtil.disableRequiredValidation(this.ui.organizationDetailsForm);
    } else {
      // Turn on required field validation for this form
      parsleyUtil.enableRequiredValidation(this.ui.organizationDetailsForm);
    }
    return this.ui.organizationDetailsForm.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.organizationId = this.model.get('organizationId');
    formData.contactId = this.model.get('contactId');
    return formData;
  }
});
